/**
 * @file: ErpSyncOrigin.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpSyncOrigin {
  System = 'system',
  User = 'user',
}

export const ErpSyncOriginValueSet = new Set([
  ErpSyncOrigin.System,
  ErpSyncOrigin.User,
]);
